import { Component, Input, OnInit } from '@angular/core';
import { SecurityService } from '@mynexus/mynexus-ui-lib';
import { ProductItem } from '@shared/models/product-options.model';
import { PlatformService } from '@core/services/platform.service';
import { ProductName } from '@core/constants';

@Component({
  selector: 'app-product-selection',
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.scss'],
  standalone: false,
})
export class ProductSelectionComponent implements OnInit {
  @Input() set defaultProduct(product: ProductName) {
    this.selectedProduct = product;
    // Initially previous product should not have empty value
    this.previousProduct = product;
  }

  productNames: ProductItem[] = [];
  selectedProduct!: ProductName;
  previousProduct!: ProductName;

  constructor(private securityService: SecurityService, private platformService: PlatformService) {}

  async ngOnInit() {
    this.productNames = (await this.platformService.getProductsAccessConfig()).reduce(
      (queues: ProductItem[], { option, access }) => {
        if (this.securityService.hasAccess(access)) {
          queues.push(option);
        }

        return queues;
      },
      []
    );
  }

  async setActiveProduct(product: ProductName): Promise<void> {
    if (this.platformService.hasUnsavedChanges) {
      try {
        await this.platformService.confirmUnsavedChangesNavigation();
        this.previousProduct = product;
        this.changeProduct();
      } catch {
        this.selectedProduct = this.previousProduct;
      }
    } else {
      this.previousProduct = product;
      this.changeProduct();
    }
  }

  private changeProduct(): void {
    this.platformService.setCurrentProduct(this.selectedProduct);
  }
}
